import React, { ButtonHTMLAttributes, ComponentType, forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import hinted from '@/components/Hinted';

export type ToolbarButtonProps = {
  active?: boolean,
  indicator?: boolean | null
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const PlainToolbarButton: ComponentType<ToolbarButtonProps> = styled(
  forwardRef<HTMLButtonElement, ToolbarButtonProps>(({ active = false, indicator, ...props }, ref) => {
    if (active) {
      props.className = `${props.className || ''} pressed`;
    }
    if (indicator === true) {
      props.className = `${props.className || ''} indicator-on`;
    }
    if (indicator === false) {
      props.className = `${props.className || ''} indicator-off`;
    }
    return <button ref={ref} {...props}/>;
  })
)({
  backgroundColor: 'transparent',
  color: '#091E42',
  width: '44px',
  height: '44px',
  fontSize: '24px',
  padding: '10px',
  borderStyle: 'none',
  borderWidth: '1px',
  borderRadius: '8px',
  '&:disabled, &.disabled': {
    color: '#ced3d9',
    backgroundColor: 'transparent',
  },
  '&:not(:disabled,.disabled):hover': {
    backgroundColor: '#E6F5FF',
  },
  '&:not(:disabled,.disabled):active, &.pressed': {
    padding: '11px 9px 9px 11px',
    boxShadow: '0px 0px 0px 1px #091e421a inset, 1px 1px 3px 0px #091E4240 inset',
  },
  '&.pressed': {
    backgroundColor: '#FAFAFA',
  },
  '&.indicator-on, &.indicator-off': {
    position: 'relative',
    '&:after': {
      content: '""',
      width: '5px',
      height: '5px',
      borderRadius: '2.5px',
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    '&:disabled:after': {
      backgroundColor: '#ced3d9',
    },
  },
  '&.indicator-on:after': {
    backgroundColor: '#4C9AFF',
  },
  '&.indicator-off:after': {
    backgroundColor: '#C1C7D0',
  },
});

const ToolbarButton = hinted(
  PlainToolbarButton,
  { placement: 'top-start', delay: 250, fadeDuration: 50, distance: 1 }
);

export default ToolbarButton;